import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { AppInsightInstrumentationKey } from "./utils/general-config";

const reactPlugin = new ReactPlugin();

// const appInsights = new ApplicationInsights({
//   config: {
//     instrumentationKey: AppInsightInstrumentationKey(),
//     extensions: [reactPlugin],
//   },
// });

// appInsights.loadAppInsights();

export default (Component) => withAITracking(reactPlugin, Component);
// export { appInsights };
